module.exports = "<div \n  class=\"loading\"\n  [hidden]=\"!source?.loading || source?.initialized\">\n    Carregando registros...\n</div>\n<ng2-smart-table\n  class=\"my-smart-table\"\n  [hidden]=\"source?.loading && !source?.initialized\"\n  [settings]=\"settings\"\n  [source]=\"source\"\n  (edit)=\"onEdit($event)\"\n  (delete)=\"onDelete($event)\"\n  (create)=\"onAdd($event)\"\n  (userRowSelect)=\"onUserRowSelect($event)\">\n</ng2-smart-table>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/datagrid/datagrid.component.html
// module id = ./src/app/components/datagrid/datagrid.component.html
// module chunks = main